import { jsx } from "react/jsx-runtime";
import { omitBy, pick, isUndefined } from "lodash";
import { isEditor } from "../../utils/isEditor.esm.js";
import { FieldConfig } from "./LoanComparison.utils.esm.js";
import LoanComparisonCalculator from "./LoanComparisonCalculator.esm.js";
const LoanComparisonBlock = {
  Component: ({
    attrs
  }) => {
    const defaultValues = omitBy(pick(attrs, Object.keys(FieldConfig)), isUndefined);
    const editorMode = isEditor();
    return /* @__PURE__ */ jsx(LoanComparisonCalculator, { editorMode, ...{
      defaultValues
    } }, isEditor() ? JSON.stringify(defaultValues) : void 0);
  },
  metadata: {
    version: "1.0",
    name: "constellation/loan-comparison-calculator",
    title: "Loan Comparison Calculator",
    description: "Compare monthly payments and costs across loan options.",
    icon: "chart-line",
    keywords: ["mortgages"],
    category: "Calculators",
    supports: {
      customClassName: false,
      html: false
    },
    attributes: {
      [FieldConfig.typeOneLoanAmount.name]: {
        type: "number",
        label: "Loan 1: Default loan amount",
        default: 3e5,
        control: "number"
      },
      [FieldConfig.typeOneLoanTerm.name]: {
        type: "string",
        label: "Loan 1: Default loan program",
        default: FieldConfig.typeOneLoanTerm.options[0].value,
        control: "select",
        choices: FieldConfig.typeOneLoanTerm.options
      },
      [FieldConfig.typeOneInterestRate.name]: {
        type: "number",
        label: "Loan 1: Default interest rate",
        default: 4.176,
        control: "number"
      },
      [FieldConfig.typeTwoLoanAmount.name]: {
        type: "number",
        label: "Loan 2: Default loan amount",
        default: 3e5,
        control: "number"
      },
      [FieldConfig.typeTwoLoanTerm.name]: {
        type: "string",
        label: "Loan 2: Default loan program",
        default: FieldConfig.typeTwoLoanTerm.options[0].value,
        control: "select",
        choices: FieldConfig.typeTwoLoanTerm.options
      },
      [FieldConfig.typeTwoInterestRate.name]: {
        type: "number",
        label: "Loan 2: Default interest rate",
        default: 4.176,
        control: "number"
      },
      [FieldConfig.typeThreeLoanAmount.name]: {
        type: "number",
        label: "Loan 3: Default loan amount",
        default: 3e5,
        control: "number"
      },
      [FieldConfig.typeThreeLoanTerm.name]: {
        type: "string",
        label: "Loan 3: Default loan program",
        default: FieldConfig.typeThreeLoanTerm.options[0].value,
        control: "select",
        choices: FieldConfig.typeThreeLoanTerm.options
      },
      [FieldConfig.typeThreeInterestRate.name]: {
        type: "number",
        label: "Loan 3: Default interest rate",
        default: 4.176,
        control: "number"
      }
    }
  }
};
export {
  LoanComparisonBlock as default
};
